/**
 * Messages actions.
 *
 * @param {FetchPath} fetchPath
 * @return {Object}
 */
export default ({ fetchPath }) => ({
  /**
   * Issue a request to send a new message.
   *
   * @param {Function} dispatch
   * @param {Object} message
   *
   * @return {Promise}
   */
  async xhrSend({ dispatch }, { message }) {
    await fetchPath.run(
      {
        method: 'POST',
        path: '/yoda/api/messages',
        data: message,
      },
    ).catch((e) => {
      dispatch('notifications/flash/create', {
        type: 'error',
        content: 'Failed to send message. Please try again.',
      }, { root: true })

      throw e
    })

    dispatch('notifications/flash/create', {
      type: 'success',
      content: 'Message successfully sent',
    }, { root: true })
  },
})
